import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { finalize, shareReplay, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Divisa } from "../models/Divisa";
import { InboxTypes } from "../shared/models/InboxType.enum";
import { Response } from "../shared/models/Response";
import { TokenStorageService } from "./token-storage.service";

@Injectable({
	providedIn: "root",
})
export class DashboardService {
	currentEmisor: string;
	private REST_API_SERVER = environment.backend_server + "/dashboard";
	private MONITORING_SERVICE = environment.backend_server + "/monitoring";
	private DIVISAS_API_SERVER = environment.backend_server + "/divisa";
	isLoadingDteSummary: Observable<boolean>;
	isLoadingServicesStatus: Observable<boolean>;
	isLoadingDailyDivisas: Observable<boolean>;
	private loadingDteSummarySubject: BehaviorSubject<boolean>;
	private loadingServicesStatusSubject: BehaviorSubject<boolean>;
	private loadingDailyDivisasSubject: BehaviorSubject<boolean>;
	private divisasCache: Response<Divisa[]> = null;
	private divisasCacheTimestamp: number = null;
	private divisasRequest$: Observable<Response<Divisa[]>> = null;
	private readonly divisasCacheTTL = 5 * 60 * 1000;

	constructor(private http: HttpClient) {
		this.loadingDteSummarySubject = new BehaviorSubject<boolean>(true);
		this.isLoadingDteSummary = this.loadingDteSummarySubject.asObservable();
		this.loadingServicesStatusSubject = new BehaviorSubject<boolean>(true);
		this.isLoadingServicesStatus = this.loadingServicesStatusSubject.asObservable();
		this.loadingDailyDivisasSubject = new BehaviorSubject<boolean>(true);
		this.isLoadingDailyDivisas = this.loadingDailyDivisasSubject.asObservable();
	}

	dteSummary(emisorId: string, sucursalId: string, diasPrevios: number): Observable<Response<any>> {
		this.loadingDteSummarySubject.next(true);
		return this.http.get<Response<any>>(this.REST_API_SERVER + "/dtesummary?emisorId=" + emisorId + "&sucursalId=" + sucursalId + "&lastNDays=" + diasPrevios).pipe(finalize(() => this.loadingDteSummarySubject.next(false)));
	}

	// monitoringServicesStatuses(): Observable<any> {
	//    this.loadingServicesStatusSubject.next(true);
	//    return this.http.get<any>(this.MONITORING_SERVICE + "/getstatus").pipe(finalize(() => this.loadingServicesStatusSubject.next(false)));
	// }

	getDailyDivisas(forceRefresh = false): Observable<Response<Divisa[]>> {
		const now = Date.now();
		if (this.divisasRequest$) return this.divisasRequest$;
		if (!forceRefresh && this.divisasCache && this.divisasCacheTimestamp && (now - this.divisasCacheTimestamp < this.divisasCacheTTL)) {
			return of(this.divisasCache);
		}

		this.loadingDailyDivisasSubject.next(true);
		this.divisasRequest$ = this.http.get<Response<Divisa[]>>(this.DIVISAS_API_SERVER + "/ListDivisas").pipe(
			tap((data) => {
					this.divisasCache = data;
					this.divisasCacheTimestamp = Date.now();
				}),
			finalize(() => {
				this.divisasRequest$ = null;
				this.loadingDailyDivisasSubject.next(false);
			}),
			shareReplay(1)
		);
		return this.divisasRequest$;
	}

	syncDivisas(): Observable<Response<boolean>> {
		this.loadingDailyDivisasSubject.next(true);
		return this.http.get<Response<boolean>>(this.DIVISAS_API_SERVER + "/SyncDivisas").pipe(finalize(() => this.loadingDailyDivisasSubject.next(false)));
	}
}
